export default "__VITE_ASSET__37964013__"